// extracted by mini-css-extract-plugin
export default {"root":"classes_root__eQmn0","ended":"classes_ended__dp+pp","in_progress":"classes_in_progress__R+WTW","icon":"classes_icon__MY5sa","text":"classes_text__sbaQe"};